import { cx, styled } from "simplydo/react/styled";

import { StyledAccordionContent } from "./Accordion.styles";
import type { AccordionContentProps } from "./Accordion.types";
import { useAccordionContext } from "./AccordionContext";

const AccordionContentComponent = ({
  active: activeProp,
  children,
  className,
  index,
  style,
  onClick,
}: AccordionContentProps) => {
  const ctx = useAccordionContext();
  const active =
    activeProp !== undefined
      ? activeProp
      : (ctx?.isIndexActive(index) ?? false);

  const classes = cx(active && "is-active", className);

  return (
    <StyledAccordionContent className={classes} style={style} onClick={onClick}>
      {children}
    </StyledAccordionContent>
  );
};

export const AccordionContent = styled(AccordionContentComponent)``;
